import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Status extends Component {
  circleCss(color) {
    return {
      'height': '15px',
      'width': '15px',
      'backgroundColor': color,
      'borderRadius': '50%',
      'display': 'inline-block',
      'marginTop': '5px',
    };
  }

  render() {
    return (
      <div>
        <span>
          {this.props.online ?
            <span style={this.circleCss('#006D4D')}></span> :
            <span style={this.circleCss('#FF6F00')}></span>
          }
        </span>
      </div>
    );
  }
}

Status.propTypes = {
  online: PropTypes.bool,
};
Status.defaultProps = {};

export default Status;
